<div class="responsive-card d-flex flex-column gap-4">
  <div class="d-flex justify-content-between">
    <div class="responsive-card-title" i18n>Account Details</div>
    <app-tertiary-button
      *ngIf="showGoToAccountButton"
      [leftIconSrc]="'assets/icons/blue/ExternalLink.svg'"
      [size]="BaseButtonSizeEnum.xs"
      (buttonClicked)="goToAccount()"
      i18n>
      View Account
    </app-tertiary-button>
  </div>
  <div class="details-card-container">
    <div class="details-card">
      <div class="d-flex gap-4 justify-content-between align-items-center w-100">
        <div class="d-flex gap-2 align-items-center">
          <span *ngIf="isAnnualMinimumEstimated; else annualMinimumLabel" class="inner-card-label" i18n>
            Estimated Annual Minimum
          </span>
          <ng-template #annualMinimumLabel>
            <span class="inner-card-label" i18n>Annual Minimum</span>
          </ng-template>
          <img
            [ngbTooltip]="isAnnualMinimumEstimated ? estimatedAnnualMinimumTooltip : (annualMinimumTooltip$ | async)"
            [triggers]="'hover focus click'"
            [style.height.rem]="1.5"
            [style.width.rem]="1.5"
            [src]="'assets/icons/grey/CircleQuestion.svg'"
            alt="" />
        </div>
        <span class="inner-card-value" i18n>{{ annualMinimumAmount | currency }}</span>
      </div>
    </div>
    <div class="details-card">
      <div class="d-flex gap-4 justify-content-between align-items-center w-100">
        <div class="d-flex gap-2 align-items-center">
          <span class="inner-card-label" i18n>Estimated Annual Total</span>
          <img
            [ngbTooltip]="estimatedAnnualTotalTooltip"
            [triggers]="'hover focus click'"
            [style.height.rem]="1.5"
            [style.width.rem]="1.5"
            [src]="'assets/icons/grey/CircleQuestion.svg'"
            alt="" />
        </div>
        <span class="inner-card-value" i18n>{{ estimatedAnnualTotal | currency }}</span>
      </div>
    </div>
    <div *ngIf="nextYearEstimatedAnnualTotal !== null" class="details-card">
      <div class="d-flex gap-4 justify-content-between align-items-center w-100">
        <span class="inner-card-label" i18n>Estimated {{ nextYear }} Total</span>
        <span class="inner-card-value">{{ nextYearEstimatedAnnualTotal | currency }}</span>
      </div>
    </div>
  </div>
</div>
